import React from "react";
import CategoryServices from "../services/CategoryServices";

import { clearClientSession, purgeLegacyAuthTokens } from "../utils/authSession";
import { clearParentSchoolSession } from "../utils/schoolImpersonation";
var UserStateContext = React.createContext();
var UserDispatchContext = React.createContext();

function userReducer(state, action) {
  switch (action.type) {
    case "LOGIN_SUCCESS":
      return { ...state, isAuthenticated: true };
    case "SIGN_OUT_SUCCESS":
      return { ...state, isAuthenticated: false };
    case "AUTH_BOOTSTRAPPED":
      return { ...state, isAuthenticated: action.isAuthenticated, bootstrapped: true };
    default: {
      throw new Error(`Unhandled action type: ${action.type}`);
    }
  }
}

function UserProvider({ children }) {
  var [state, dispatch] = React.useReducer(userReducer, {
    isAuthenticated: false,
    bootstrapped: false,
  });

  React.useEffect(() => {
    let cancelled = false;
    CategoryServices.getMe()
      .then((res) => {
        if (cancelled) return;
        localStorage.setItem("userDetail", JSON.stringify(res));
        if (res.screens) {
          localStorage.setItem("rbac_screens", JSON.stringify(res.screens));
        }
        if (res.permissions) {
          localStorage.setItem("rbac_permissions", JSON.stringify(res.permissions));
        }
        // Migrate away from legacy LS tokens if present.
        purgeLegacyAuthTokens();
        dispatch({ type: "AUTH_BOOTSTRAPPED", isAuthenticated: true });
      })
      .catch(() => {
        if (cancelled) return;
        dispatch({ type: "AUTH_BOOTSTRAPPED", isAuthenticated: false });
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <UserStateContext.Provider value={state}>
      <UserDispatchContext.Provider value={dispatch}>
        {children}
      </UserDispatchContext.Provider>
    </UserStateContext.Provider>
  );
}

function useUserState() {
  var context = React.useContext(UserStateContext);
  if (context === undefined) {
    throw new Error("useUserState must be used within a UserProvider");
  }
  return context;
}

function useUserDispatch() {
  var context = React.useContext(UserDispatchContext);
  if (context === undefined) {
    throw new Error("useUserDispatch must be used within a UserProvider");
  }
  return context;
}

export { UserProvider, useUserState, useUserDispatch, loginUser, signOut };

function loginUser(dispatch, login, password, history, setIsLoading, setError, roleType,
   handlePasswordChangeConfirm) {
  setError(false);
  setIsLoading(true);
  if (!!login && !!password) {
    const  userDetails =   {"email":login,"password":password, "role":roleType}
    CategoryServices.creteUserLogin(userDetails).then((res) => {
      clearParentSchoolSession();
      localStorage.setItem('userDetail', JSON.stringify(res));
      // Tokens are HttpOnly cookies for web — do not persist JWTs in localStorage.
      purgeLegacyAuthTokens();
      if (res.screens) {
        localStorage.setItem('rbac_screens', JSON.stringify(res.screens));
      }
      if (res.permissions) {
        localStorage.setItem('rbac_permissions', JSON.stringify(res.permissions));
      }
      setError(null)
      setIsLoading(false)
     
      
 if(res.role === "SUPERADMIN"){
  dispatch({ type: 'LOGIN_SUCCESS' })
  history.push('/app/schooldetails') ;
 }else if(res.role === "PARENT" ){
  if(res.passwordReset===false){
    
    handlePasswordChangeConfirm();
    return; 
    }else{
      
      dispatch({ type: 'LOGIN_SUCCESS' })
      history.push('/app/assignment') ;
    }

 }else if (res.role === "TEACHER") {
  dispatch({ type: 'LOGIN_SUCCESS' });
  history.push('/app/studentactivity');
}else if(res.role === "SCHOOLE"){
  dispatch({ type: 'LOGIN_SUCCESS' });
  history.push('/app/addbranchschool'); 
}

else {
  dispatch({ type: 'LOGIN_SUCCESS' });
  history.push('/app/studentdetails');
}

    }).catch((err) => {
      const errorMessage = err.response?.data?.message
      alert(errorMessage)
      setIsLoading(false);
      history.push('/montessori/login')
    });
  } 
}
function signOut(dispatch, history) {
  CategoryServices.logoutUser({}).catch(() => {});
  clearClientSession();
  clearParentSchoolSession();
  dispatch({ type: "SIGN_OUT_SUCCESS" });
  history.push("/montessori/login");
}
